export const FoxVehicleCLassRequest = function (vehicleClassCode) {
    this.classCode = vehicleClassCode || null;
};